import { render } from "./config-UK.vue?vue&type=template&id=b86d19c4"
import script from "./config-UK.vue?vue&type=script&lang=js"
export * from "./config-UK.vue?vue&type=script&lang=js"

import "./config-UK.vue?vue&type=style&index=0&id=b86d19c4&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__